import { observer } from "mobx-react-lite"
import { useEffect } from "react"
import { Outlet, useParams } from "react-router-dom"
import LowSpinner from "../../../../components/common/low-spinner"
import usersStore from "features/users/store/users-store"


const UserLoader: React.FC = observer(() => {
    const { userDetailsLoading, loadUserAsync, users } = usersStore
    const { userId } = useParams()
    const user = users.find(u=>u.id === userId)
    useEffect(() => {
        if (user && userId) {
            loadUserAsync(userId)
        }
    }, [userId])

    if (userDetailsLoading) {
        return <LowSpinner id='user.loading' />
    }

    return <Outlet />
})

export default UserLoader
